export default "__VITE_ASSET__DB9FOiy9__"